import { Select } from '@mantine/core';
import classes from '../input.module.css';
import { defaultInputProps } from '../default-props';
export const selectProps = Select.extend({
    classNames: classes,
    defaultProps: defaultInputProps,
});
